module.exports = __webpack_public_path__ + "static/james-lamp-257b136506134217b0c04a687fd6a919.jpg";